export const API_BASE_URL = process.env.REACT_APP_API_PATH;
export const API_SITE_URL = process.env.REACT_APP_API_SITE_URL;
export const APP_SITE_URL = process.env.REACT_APP_SITE_URL;

export const TOKEN = localStorage.getItem("user_token");
export const UPLOAD_URL = `${API_SITE_URL}/storage/uploads`;
export const HEADERS = { headers: { Authorization: `Bearer ${TOKEN}` } };
